import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCd"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Circle cx="12" cy="12" r="2.5" stroke="currentColor"/><Path d="M11.0016 5.57666C8.1863 6.01138 5.96739 8.25266 5.56641 11.079M18.4252 13.0002C17.9945 15.7893 15.7907 17.9931 13.0016 18.4238" stroke="currentColor"/></CentralIconBase>;
});

export default IconCd;
